/**
 * Units Hooks
 *
 * React Query hooks for Units data fetching.
 */

import { useQuery } from '@tanstack/react-query';
import { unitsService } from '../services/raw-products.service';

/**
 * Hook to fetch all units
 */
export function useUnits() {
  return useQuery({
    queryKey: ['units', 'list'],
    queryFn: () => unitsService.list(),
    staleTime: 10 * 60 * 1000, // 10 minutes - units rarely change
  });
}

/**
 * Hook to fetch units grouped by type
 */
export function useUnitsByType() {
  return useQuery({
    queryKey: ['units', 'by-type'],
    queryFn: () => unitsService.getByType(),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
